import Cookies from 'js-cookie';
import config from '../config.json';


function msToDays(ms) {
  return Math.floor(ms / (24 * 60 * 60 * 1000));
}

export function setAuthCookie(token, expirationTime, keepSignedIn=false) {
  return Cookies.set(
    config.jwtCookieName,
    token, {
      expires: keepSignedIn && msToDays(expirationTime)
    }
  );
}

export function removeAuthCookie() {
  return Cookies.remove(config.jwtCookieName);
}

export function getAuthCookie() {
  return Cookies.get(config.jwtCookieName); 
}


// WEBPACK FOOTER //
// src/utils/cookies.js